import { render, staticRenderFns } from "./FrameBody.vue?vue&type=template&id=ac2f371e"
import script from "./FrameBody.vue?vue&type=script&lang=ts"
export * from "./FrameBody.vue?vue&type=script&lang=ts"
import style0 from "./FrameBody.vue?vue&type=style&index=0&id=ac2f371e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports